




"use strict";

export default class TableToggle {

    constructor () {
        if ( document.querySelector('.more-eigenschappen') ) {
            document.querySelector('.more-eigenschappen').addEventListener('click', evt => {
                evt.currentTarget.style.display = 'none';
                if ( document.querySelector('.less-eigenschappen') ) {
                    document.querySelector('.less-eigenschappen').style.display = 'block';
                }
                document.querySelector('.eigenschappen-tabel').classList.add('full');
            });
        }

        if ( document.querySelector('.less-eigenschappen') ) {
            document.querySelector('.less-eigenschappen').addEventListener('click', evt => {
                evt.currentTarget.style.display = 'none';
                if ( document.querySelector('.more-eigenschappen') ) {
                    document.querySelector('.more-eigenschappen').style.display = 'block';
                }
                document.querySelector('.eigenschappen-tabel').classList.remove('full');
            });
        }
    }

}
